import { render, staticRenderFns } from "./PouringCategories.vue?vue&type=template&id=038d4072&"
import script from "./PouringCategories.vue?vue&type=script&lang=js&"
export * from "./PouringCategories.vue?vue&type=script&lang=js&"
import style0 from "./PouringCategories.vue?vue&type=style&index=0&id=038d4072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports